import * as Isemail from 'isemail';
import { size } from 'lodash';
import React, { Fragment } from 'react';
import styled from 'styled-components';

import { ReactComponent as ErrorIcon } from '@src/assets/escher/icons/error-filled.svg';

const HAS_ERR_PADDING = '0px';

const Input = styled.input`
  outline: none !important;
  font-size: ${props => props.theme.font.fontMd};
  padding: 10px 14px;
  height: 40px;
  box-shadow: none;
  border: none;
  background: none;
  width: 100%;
`;

const ErrorBlock = styled.div`
  color: ${props => props.theme.invalid};
  margin: 15px 0px 15px 10px;
`;

const ErrorWithIcon = styled.div`
  svg {
    vertical-align: middle;
    padding-bottom: 2px;
  }
`;

const InputContainer = styled.div`
  border-radius: ${props => props.theme.inputBorderRadius};
  margin-bottom: ${props =>
    size(props.error) ? HAS_ERR_PADDING : props.theme.gutter};
  border: ${props => props.theme.borderMd};
  transition: 1000ms border-color ease;
  border-color: ${props =>
    props.valid === -1
      ? props.theme.invalid
      : props.valid
      ? props.theme.valid
      : '#D2D6D9'};
  width: 100%;
  display: inline-block;
  position: relative;
  &:nth-child(3) {
    /* margin-bottom: 10px; */
  }
`;

const Placeholder = styled.div`
  position: absolute;
  background: white;
  top: -11px;
  padding: 4px;
  left: 10px;
  font-size: 12px;
  color: grey;
`;

const getIfValid = (inputType, value) => {
  switch (inputType) {
    case 'email':
      return Isemail.validate(value) ? true : -1;
    default:
      return true;
  }
};

export const ErrorMessage = ({ error = '' }) => {
  if (size(error)) {
    return (
      <ErrorBlock>
        <ErrorWithIcon>
          <ErrorIcon width={'17px'} height={'17px'} />
          &nbsp;{error}
        </ErrorWithIcon>
      </ErrorBlock>
    );
  }
  return null;
};

const AuthInput = props => {
  const { optional, style, error } = props;

  const handleChange = e => {
    e.preventDefault();
    e.stopPropagation();
    e.persist();
    props.onChange(e.target.value);
  };

  const valid =
    props.value &&
    props.type === 'email' &&
    getIfValid(props.type, props.value);

  return (
    <Fragment>
      <InputContainer valid={valid} style={style} error={error}>
        {props.placeholder && <Placeholder>{props.placeholder}</Placeholder>}
        {optional ? (
          <Input {...props} onChange={handleChange} />
        ) : (
          <Input {...props} onChange={handleChange} required />
        )}
      </InputContainer>
      <ErrorMessage error={error} />
    </Fragment>
  );
};

AuthInput.defaultProps = {
  onChange: () => {},
  style: {},
};

AuthInput.displayName = 'Authentication Input';

export default AuthInput;
